import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';

import {
  ListDisplay,
  ButtonIconContextual,
  Grid,
  ContentDisplay,
  Heading,
  BaseText
} from '@warrenbrasil/nebraska-web';
import { DetailsModal } from '@/modules/catalog/views/FundsAcquisition/components/DetailsModal';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

import {
  IAbout,
  IRiskProfile
} from 'src/modules/catalog/services/funds/funds-types';

enum ERiskTypes {
  Passive = 'Passive',
  PassiveModerated = 'PassiveModerated',
  Moderated = 'Moderated',
  AggressiveModerated = 'AggressiveModerated',
  Aggressive = 'Aggressive',
  Aggressive2 = 'Aggressive2'
}

interface Props {
  about: IAbout;
  risk: IRiskProfile;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'About',
  props: {
    about: null,
    risk: null
  },
  setup(__props: any) {

const props = __props as {
  about: IAbout;
  risk: IRiskProfile;
};



const isDetailsModalOpen = ref(false);
const detailsModalTitle = ref('');
const detailsModalDescription = ref('');

const title = computed(() => {
  return props.about?.title || '-';
});

const leftListDetails = computed(() => {
  const half = Math.round(props.about.rows.length / 2);

  return props.about.rows.slice(0, half);
});

const rightListDetails = computed(() => {
  const half = Math.round(props.about.rows.length / 2);

  return props.about.rows.slice(half);
});

const riskColor = computed(() => {
  const riskColorMap = {
    [ERiskTypes.Passive]: NebraskaColors.riskLow,
    [ERiskTypes.PassiveModerated]: NebraskaColors.riskLow,
    [ERiskTypes.Moderated]: NebraskaColors.riskMedium,
    [ERiskTypes.AggressiveModerated]: NebraskaColors.riskHigh,
    [ERiskTypes.Aggressive]: NebraskaColors.riskHigh,
    [ERiskTypes.Aggressive2]: NebraskaColors.riskHigh
  };

  return (
    riskColorMap[props.risk.portfolioRiskProfile.value] ||
    NebraskaColors.riskLow
  );
});

function openDetailsModal(title: string, description: string) {
  detailsModalTitle.value = title;
  detailsModalDescription.value = description;

  isDetailsModalOpen.value = true;
}

return { __sfc: true,ERiskTypes, props, isDetailsModalOpen, detailsModalTitle, detailsModalDescription, title, leftListDetails, rightListDetails, riskColor, openDetailsModal, ListDisplay, ButtonIconContextual, Grid, ContentDisplay, Heading, BaseText, DetailsModal, NebraskaColors }
}

})